import {
  Button,
  Card,
  Description,
  FlexGrid,
  Image,
  RoundedIcon,
  Typography,
  useThemeProvider,
} from '@albo-ui/core';
import { useEffect } from 'react';
import { useCookieUsePolicyNotification } from '../../providers/cookie-use-policy-notification-provider';
import { useTranslator } from '../../providers/translator-provider';
import { GetMainItems, GetRightSideList } from './const';
import { Point } from './styled';

export type OnBoardingIntroPFAEProps = {
  onClick: () => void;
};

export const OnBoardingIntroPFAE = ({ onClick }: OnBoardingIntroPFAEProps) => {
  const { theme } = useThemeProvider();
  const { bottomItems, topCards } = GetMainItems();
  const { list } = GetRightSideList();
  const { show, cookiesNotAccepted } = useCookieUsePolicyNotification();

  const {
    ON_BOARDING_INTRO_TITLE,
    ON_BOARDING_INTRO_BUTTON_TEXT,
    ON_BOARDING_INTRO_PM_RIGHT_SIDE_TITLE,
    ON_BOARDING_INTRO_PFAE_SUBTITLE,
    BUSINESS_HELP_EMAIL,
  } = useTranslator();

  useEffect(() => {
    if (cookiesNotAccepted) show();
  }, [show, cookiesNotAccepted]);

  return (
    <FlexGrid
      container
      fullWidth
      fullHeight
      style={{ backgroundColor: theme.colors.snow }}
    >
      <FlexGrid
        container
        fullHeight
        fullWidth
        padding={8}
        spacing={6}
        direction='column'
      >
        <FlexGrid
          item
          container
          direction='column'
          spacing={1}
          style={{ textAlign: 'center' }}
        >
          <FlexGrid item>
            <Typography variant='h2' color='indigo'>
              {ON_BOARDING_INTRO_TITLE}
            </Typography>
          </FlexGrid>
          <FlexGrid item>
            <Typography variant='smallTitle' color='neutral'>
              {ON_BOARDING_INTRO_PFAE_SUBTITLE}
            </Typography>
          </FlexGrid>
        </FlexGrid>
        <FlexGrid item container justify='space-between'>
          {topCards.map(({ icon, text, images }, index) => (
            <Card height='250px' width='244px'>
              <FlexGrid
                container
                fullWidth
                fullHeight
                spacing={3}
                alignItems='center'
                direction='column'
              >
                <FlexGrid item>
                  <Typography variant='h1' color='indigo'>
                    {index + 1}.
                  </Typography>
                </FlexGrid>
                <FlexGrid
                  item
                  container
                  direction='column'
                  alignItems='center'
                  spacing={1}
                  style={{ textAlign: 'center' }}
                >
                  <FlexGrid item>{icon}</FlexGrid>
                  <FlexGrid item>
                    <Typography variant='paragraph'>{text}</Typography>
                  </FlexGrid>
                  {images && (
                    <FlexGrid item container alignItems='center' spacing={1}>
                      {images.map((image) => (
                        <FlexGrid item>
                          <Image src={image} size='73px' />
                        </FlexGrid>
                      ))}
                    </FlexGrid>
                  )}
                </FlexGrid>
              </FlexGrid>
            </Card>
          ))}
        </FlexGrid>
        <FlexGrid item container justify='center'>
          <Button onClick={onClick} size='large' disabled={cookiesNotAccepted}>
            {ON_BOARDING_INTRO_BUTTON_TEXT}
          </Button>
        </FlexGrid>
        <FlexGrid item container justify='space-between'>
          {bottomItems.map(({ icon, text, color, width }, index) => (
            <FlexGrid item>
              <Description
                icon={<RoundedIcon size='normal' icon={icon} color={color} />}
                orientation='vertical'
                width={width}
              >
                {text}{' '}
                {index === 2 && (
                  <Typography variant='paragraph' bold>
                    {BUSINESS_HELP_EMAIL}
                  </Typography>
                )}
              </Description>
            </FlexGrid>
          ))}
        </FlexGrid>
      </FlexGrid>
      <FlexGrid
        item
        container
        spacing={5}
        direction='column'
        style={{
          backgroundColor: theme.colors.primary,
          width: '50%',
          padding: theme.spacesPx[9],
        }}
      >
        <FlexGrid item>
          <Typography variant='h2' color='white'>
            {ON_BOARDING_INTRO_PM_RIGHT_SIDE_TITLE}
          </Typography>
        </FlexGrid>
        <FlexGrid item container direction='column' spacing={3}>
          {list.map((text) => (
            <FlexGrid container item spacing={1} direction='row'>
              <FlexGrid item>
                <Point />
              </FlexGrid>
              <FlexGrid item>
                <Typography
                  variant='smallTitle'
                  color='white'
                  style={{ fontWeight: 400 }}
                >
                  {text}
                </Typography>{' '}
              </FlexGrid>
            </FlexGrid>
          ))}
        </FlexGrid>
      </FlexGrid>
    </FlexGrid>
  );
};
